export default {
  isochrones: {
    isochrones: 'Izochrony',
    isochronesReady: 'Izochrony připraveny',
    calculatingIsochrones: 'Výpočet izochron ...',
    itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions: 'S definovanými možnostmi nebylo možné izochrony vypočítat. Zkuste definovat menší izochrony.',
    couldResolveTheSelectedPlaceAsASuitableCenter: 'Vybraný bod nebylo možné vyřešit jako vhodný střed.',
    apiError: {
      2003: 'Plocha polygonu, kterému je třeba se vyhnout, nesmí překročit 20,0000 km2.',
      3001: 'Jeden nebo více parametrů má nesprávnou hodnotu nebo formát.',
      3003: 'Parametr \'avoid_features\' má nesprávnou hodnotu \'null\'.',
      3004: 'Vybraná kombinace profilu, intervalu a času nebo vzdálenosti překračuje maximální podporovanou hodnotu. Hodnoty upravte.',
      3099: 'Nelze sestavit izochronní mapu pro vybraný bod (body) a profil.'
    },
    genericErrorMsg: 'Izochrony nebylo možné vypočítat.',
    timeoutError: 'Žádost trvala příliš dlouho a byla přerušena. Zkuste menší rozsahy nebo intervaly.'
  }
}
